// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__14x8f","label":"Completed_label__3K-0u"};